// Single Product block schema - Showcase one shop product with Buy Now
export const singleProductSchema = {
  type: 'single-product',
  label: 'Single Product',
  description: 'Showcase a product with a Buy Now button',
  icon: 'PackageOpen',
  defaultContent: {
    heading: '',
    productId: '',
    buttonText: 'Buy Now',
    showDescription: true,
    layout: 'imageLeft', // 'imageLeft' | 'imageRight'
    style: {},
  },
};
